<template>
  <component
    v-bind="$attrs"
    v-on="$listeners"
    :is="component"
    :to="to || null"
    :class="classes"
    :active-class="!isExternal ? '-active' : null"
    :exact-active-class="!isExternal ? '-active' : null"
  >
    <c-icon
      v-if="icon"
      class="icon"
      :icon="icon"
      :width="iconSize"
      :height="iconSize"
    />

    <span class="text">
      <slot />
    </span>
  </component>
</template>

<script>
import isExternal from '@/helpers/isExternal'

export default {
  props: {
    alternative: Boolean,
    icon: String,
    iconSize: {
      type: String,
      default: '17'
    },
    active: Boolean,
    to: [String, Object],
    isNuxt: Boolean,
    isStatic: Boolean
  },
  computed: {
    classes () {
      const classes = {
        'c-navigation-item': true,
        '-active': this.active,
        '-alt': this.alternative
      }
      return classes
    },
    isExternal () {
      const result = isExternal(this.to)
      return result
    },
    component () {
      const component = this.isExternal || this.isStatic
        ? 'a' : this.isNuxt
          ? 'nuxt-link' : 'router-link'
      return component
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-navigation-item-padding: 8px 12px !default;
$c-navigation-item-color: #8e93b1 !default;

$c-navigation-item-text-font-size: 11px !default;
$c-navigation-item-text-font-family: $c-font-family-title !default;
$c-navigation-item-text-font-weight: 300 !default;
$c-navigation-item-active-color: $c-color-primary !default;

.c-navigation-item {
  & {
    cursor: pointer;
    margin-bottom: -1px;
    display: flex;
    padding: $c-navigation-item-padding;
    border-bottom: 3px solid transparent;
    text-decoration: none;
    color: #8c92b1;
    transition: border-bottom-color .5s ease;
    @include medium-down { padding: 12px; }
  }

  &.-alt {
    display: flex;
    flex-flow: row wrap;
    text-align: center;
    padding-bottom: 10px;
    padding-top: 12px;

    & > .icon {
      flex: 0 auto;
      margin: 0 auto 9px;
    }

    & > .text {
      flex: 0 100%;
    }
  }

  & > .icon {
    fill: #bec1d4 !important;
    transition: fill .5s ease;
  }

  & > .text {
    font-size: $c-navigation-item-text-font-size;
    font-weight: $c-navigation-item-text-font-weight;
    font-family: $c-navigation-item-text-font-family;
    text-transform: uppercase;
    color: #8c92b1;
    transition: color .5s ease;
    white-space: nowrap;
  }
  &:hover {
    & > .icon { fill: #8c92b1 !important; }
    & > .text { color: #5e6684; }
  }

  &.-active {
    border-bottom-color: $c-color-primary;
    & > .icon { fill: $c-color-primary !important; }
    & > .text { color: $c-color-primary !important; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CNavigationItem.vue